<div class="form-check mb-3">
  <input
    type="checkbox"
    class="form-check-input"
    [id]="inputId"
    [checked]="checked"
    [disabled]="disabled"
    (click)="onCheckboxClick($event)"
    (blur)="onTouched()"
  />
  <label class="form-check-label text-muted" [for]="inputId">
    I have read the
    <a
      (click)="openTerms()"
      class="btn-link text-small btn-primary"
      href="javascript:;"
    >
      terms and conditions</a
    >
  </label>
</div>

<ng-template #template>
  <div class="modal-header">
    <h4 class="modal-title pull-left">
      First Orion - Branded Calling Services
    </h4>
    <img
      class="pointer"
      src="assets/images/cross-icon.svg"
      (click)="modalRef?.hide()"
    />
  </div>
  <div class="modal-body" (scroll)="onTermsScroll($event)">
    <div class="et_pb_text_inner">
      <h2>BRANDED CALLING SERVICES</h2>
      <h2>TERMS AND CONDITIONS</h2>
      <p>Dated 7 October 2026<br />Version 1.0</p>
      <p>
        These Branded Calling Services Terms and Conditions (the "Terms"),
        together with each applicable Order, the Data Processing Addendum, the
        Acceptable Use Policy, any applicable Pass-Through Terms, and any other
        terms expressly incorporated by reference, constitute the "Agreement"
        between First Orion UK Ltd. ("First Orion," "we," "us," or "our") and
        the business enterprise creating a Customer account or identified as the
        end-user customer in an Order ("Customer," "you," or "your"). The
        Agreement becomes effective on the Effective Date.
      </p>
      <p>
        These Terms, the Data Processing Addendum, the Acceptable Use Policy,
        and the Pass-Through Terms are available on the First Orion Global
        Privacy and Legal Dashboard at
        <a href="https://firstorion.com/legal" target="_blank" rel="noopener"
          >https://firstorion.com/legal</a
        >
        (the "Legal Dashboard"). First Orion may update these Terms, the
        Acceptable Use Policy, the Pass-Through Terms, and other policies posted
        on the Legal Dashboard from time to time. Notice of any material update
        will be provided to the Administrator at least thirty (30) days before
        the update takes effect; provided that advance notice may not be
        possible when an update is required by applicable law, regulation, or a
        Distribution Partner. Updated documents will be posted on the Legal
        Dashboard and will supersede prior versions as of their stated effective
        date. Orders and the Data Processing Addendum may be amended only in
        accordance with their terms or by written agreement of the parties.
        Customer’s continued use of the Services after the effective date of an
        update constitutes acceptance of the updated terms.
      </p>
      <p>
        Capitalized terms have the meanings assigned to them in these Terms.
        First Orion and Customer may each be referred to as a "party" and
        together as the "parties."
      </p>
      <p><strong>1. Definitions</strong></p>
      <p>
        "A Number" means an outbound calling telephone number used by or on
        behalf of Customer.
      </p>
      <p>
        "Administrator" means the person(s) designated by Customer to be
        authorised and responsible for creating and maintaining User IDs,
        passwords, or other security credentials on Customer’s behalf.
      </p>
      <p>
        "Affiliate" means any entity that directly or indirectly controls, is
        controlled by, or is under common control with, the party specified. For
        purposes of this definition, "control" means direct or indirect
        ownership of more than fifty percent (50%) of the voting interests of
        the subject entity.
      </p>
      <p>
        "Agent" means an agent or representative who Customer authorises in
        writing to act on the Customer’s behalf in connection with the
        Agreement, including any Order, the Euro Portal, or the Services.
      </p>
      <p>
        "Agreement" means, collectively, these Terms, each applicable Order, the
        Data Processing Addendum, the Acceptable Use Policy, any applicable
        Pass-Through Terms, and any other terms expressly incorporated by
        reference.
      </p>
      <p>
        "Authenticated" means a call that has been verified using Call
        Authentication.
      </p>
      <p>
        "B Number" means the called party telephone number of a subscriber of a
        Distribution Partner.
      </p>
      <p>
        "Business Process Outsourcer" or "BPO" means a business that originates
        calls on behalf of an enterprise under a written agreement with that
        enterprise.
      </p>
      <p>
        "Call Authentication" means First Orion’s end-to-end authentication
        method that pairs an A Number with a B Number at the time of a call
        using application programming interfaces ("APIs"), SIP configuration, or
        another supported protocol.
      </p>
      <p>"Call Logo" means a logo image delivered with an INFORM call.</p>
      <p>"Call Reason" means the stated reason for an INFORM call.</p>
      <p>
        "Content" means, individually or collectively, an Inform Display, Call
        Logo, and Call Reason delivered for display on a Device. Delivery of
        Content may be referred to as branding a call or delivering a branded
        call.
      </p>
      <p>
        "Customer Data" means content, data, and other information in any
        format, which is submitted, uploaded, transmitted, or otherwise made
        available by or for Customer to First Orion in connection with the use
        of the Services. Customer Data may include, as applicable, Customer’s
        business name, Content, A Numbers submitted for branding, branded
        calling volumes, B numbers, call traffic information, and performance
        indicators used to provide, measure, support, monitor, and protect the
        Services. Customer Data does not include data that has been irreversibly
        de-identified in accordance with applicable law such that it cannot
        reasonably be used to identify Customer or any individual.
      </p>
      <p>
        "Data Protection Laws" means, with respect to a party, all data
        protection laws, rules, regulations and orders of governmental authority
        (including laws, rules, and orders of governmental authorities of the
        European Union ("EU"), the European Economic Area ("EEA") and their
        Member States, Switzerland, the United Kingdom ("UK"), the United States
        of America, and the privacy and data protections laws and regulations of
        any other country) to the extent applicable to such party’s processing
        of Personal Data under the Agreement.
      </p>
      <p>
        "Device" means a handset or similar device capable of displaying Content
        associated with an incoming call.
      </p>
      <p>
        "Distribution Partner" means a third party that provides functionality
        or capability used to distribute Content or otherwise deliver the
        applicable Services.
      </p>
      <p>
        "Distribution" means functionality or capability, whether provided by
        First Orion or a Distribution Partner, that enables delivery of Content
        to Devices.
      </p>
      <p>
        "Documentation" means First Orion’s documentation, including
        instructions, usage guides, and policies relating to the operation and
        use of the Services that First Orion makes available through the Euro
        Portal or otherwise provides to Customer.
      </p>
      <p>
        "Effective Date" means the earlier of (i) Customer’s acceptance of these
        Terms through the Euro Portal or (ii) the effective date stated in an
        Order.
      </p>
      <p>
        "Euro Portal" means the First Orion portal through which Customer can
        utilize Services offered by First Orion. The Euro Portal can be accessed
        at
        <a
          href="https://portal-eu.firstorion.com"
          target="_blank"
          rel="noopener"
          >https://portal-eu.firstorion.com</a
        >.
      </p>
      <p>
        "Fees" means all amounts payable by Customer to First Orion for the use
        of the Services, including ongoing fees and any other fees or charges
        set out in the applicable Order.
      </p>
      <p>
        "INFORM" means First Orion’s branded calling Service that enables
        Customer to set an Inform Display for registered A Numbers used for
        outbound calls to Devices.
      </p>
      <p>
        "Inform Display" means the alphanumeric caller name delivered to a
        Device through the use of the Services. The number of characters,
        including spaces, depends on the applicable Distribution channel.
      </p>
      <p>
        "INFORM with Logo" means First Orion’s branded calling Service that
        enables delivery of a Call Logo and Call Reason, in addition to the
        Inform Display, with an Authenticated INFORM call to a Device.
      </p>
      <p>
        "Order" means an ordering document or online agreement that specifies
        the Services to be provided by First Orion to Customer, the associated
        Fees, and any additional terms and conditions.
      </p>
      <p>
        "Partner" means a partner or distributor authorised by First Orion to
        refer, distribute, or sell the Services to Customers.
      </p>
      <p>
        "Pass-Through Terms" means the flow-down provisions imposed by a
        Distribution Partner for use of its functionality or capability. The
        Pass-Through Terms form part of the Agreement when Customer uses the
        applicable Distribution Partner’s functionality or capability.
      </p>
      <p>
        "Personal Data" has the meaning given to that term, or to an equivalent
        term such as "personal information," under applicable Data Protection
        Laws.
      </p>
      <p>
        "Program" means the instructions established for a particular calling
        purpose, including the applicable A Number, Content, and period during
        which the Content should be delivered.
      </p>
      <p>
        "Services" means the products and services identified in an Order or
        otherwise made available to Customer under the Agreement, together with
        related access to the Euro Portal, applications, tools, configurations,
        plug-ins, APIs, technical support, features, functionality, and
        connectivity provided through First Orion’s proprietary platform.
      </p>
      <p>
        "Subscription Period" means the period for which Customer purchases a
        prepaid subscription to INFORM as set forth in the Order or plan
        description.
      </p>
      <p>
        "Usage Data" means data and other information relating to the access,
        use, operation, security, support, performance, configuration,
        functionality, and availability of the Services, the Euro Portal, APIs,
        and related systems. Usage Data may include technical logs, metadata,
        telemetry, diagnostic information, authentication records, audit
        records, system performance information, error reports, and aggregated
        or statistical information regarding use of the Services. For clarity,
        Usage Data does not include Customer Data or Personal Data in
        identifiable form, except to the extent such information has been
        aggregated or de-identified in accordance with applicable law such that
        it no longer identifies Customer or any individual.
      </p>
      <p>
        "User" means a person who has created a User account on the Euro Portal
        and is authorised to access the Euro Portal and use the Services on
        behalf of Customer.
      </p>
      <p><strong>2. Account Creation</strong></p>
      <ol type="a">
        <li>
          Administrators. Customer will appoint one or more Administrators
          responsible for assigning and revoking User access. The individual who
          initially creates the Customer account will be an Administrator and
          may grant equivalent administrative privileges to other Users. Each
          Administrator may create and maintain User accounts, assign and revoke
          access privileges, and manage Users’ actions and permissions as
          permitted by the Euro Portal. An Administrator may electronically
          accept agreements and amendments relating to the Customer account and
          Services on Customer’s behalf. Customer represents that each
          Administrator has authority to act for Customer, and Customer is
          responsible for each Administrator’s decisions and actions.
        </li>
        <li>
          Users. Each User will establish a user ID and password ("User
          Credentials"). Customer is responsible for limiting access to
          authorised Users and maintaining the confidentiality of User
          Credentials. Customer will require Users not to share User Credentials
          with unauthorised persons and will notify First Orion promptly of
          unauthorised use. First Orion will not be liable for loss or damage
          arising from unauthorised use except to the extent caused by First
          Orion’s breach of the Agreement. Customer is responsible for its
          Users’ activities, including Orders placed and use of Customer Data,
          and actions taken through a Customer account will be treated as
          authorised by Customer.
        </li>
        <li>
          Communications with Administrators and Users. By creating a Customer
          account or User account, each Administrator and User consents to
          receive operational communications at the registered email address,
          including (i) notices concerning Customer’s use of the Services, (ii)
          updates to the Services, and (iii) administrative and legally required
          messages. Advertising and marketing communications will be sent only
          as permitted by applicable law and in accordance with the recipient’s
          communication preferences. Subject to applicable law and, where
          required, the recipient’s prior consent, First Orion may also send
          Administrators and Users promotional communications regarding First
          Orion’s products, services, features, and offers. Recipients may
          withdraw their consent to or opt out of promotional communications at
          any time by using the unsubscribe or opt-out instructions included in
          the applicable communication or by contacting First Orion at
          <a href="mailto:support@firstorion.com">support&#64;firstorion.com</a
          >. Opting out of promotional communications will not affect
          service-related communications that are necessary to administer the
          Customer Account, provide the Services, or comply with applicable law.
          Text-message recipients may also reply STOP to opt out or HELP for
          assistance where those commands are supported. Message frequency
          varies, and standard message and data rates or other carrier charges
          may apply.
        </li>
        <li>
          Developer Portal. In order to access or use certain Services, it may
          be necessary to connect your applications, websites, products,
          services, or platforms to the Euro Portal. You may access First Orion
          Preview Materials, Credentials, or First Orion Developer Tools (as
          defined in the Developer Terms located on the Legal Dashboard) to do
          so. In addition to the Agreement, provisions applicable to your access
          and use of First Orion Preview Materials, Credentials, and Developer
          Tools can be found in the Developer Terms.
        </li>
      </ol>
      <p><strong>3. Business Vetting</strong></p>
      <ol type="a">
        <li>
          Registration. To use the Services, Customer must satisfy First Orion’s
          vetting process by registering through the Euro Portal. Customer will
          provide true, accurate, current, and complete business information,
          including its business name, physical address, telephone number,
          website, company registration number, industry code, DUNS number if
          applicable, contact information, A Numbers, call purposes, call
          categories, and other reasonably requested information. First Orion
          may review information submitted by Customer together with
          supplemental sources used for business verification. Customer will
          keep its registration information current for as long as it uses the
          Services. Following approval, First Orion may share relevant
          registration information with applicable Distribution Partners so they
          may approve or reject Customer’s use of their Distribution
          capabilities. First Orion may accept or reject a registration in its
          discretion. If Customer breaches the Agreement, including its payment
          obligations, First Orion may prohibit Customer from registering
          additional businesses until the breach is remedied.
        </li>
        <li>
          Continued Right to Use A Numbers. Customer represents and warrants
          that it owns or otherwise has the right to use each A Number submitted
          for registration or use with the Services. Customer will promptly
          notify First Orion and remove an A Number from registration when
          Customer no longer owns or has the right to use that A Number.
        </li>
      </ol>
      <p><strong>4. First Orion Responsibilities</strong></p>
      <ol type="a">
        <li>
          Right to Access and Use. Subject to the Agreement, First Orion grants
          Customer a limited, non-exclusive, non-transferable, and
          non-sublicensable right, during the term of the applicable Order, for
          authorised Users to access and use the Euro Portal and Services for
          Customer’s internal business purposes and other uses expressly
          permitted by the applicable Order.
        </li>
        <li>
          Provision of Services. First Orion will (i) make the Services
          available in accordance with the Agreement and Documentation; (ii)
          maintain commercially reasonable administrative, technical, and
          physical safeguards for Customer Data; (iii) comply with laws
          applicable to First Orion’s provision of the Services generally; (iv)
          process Customer Data in accordance with the Agreement; and (v) use
          trained, qualified personnel to provide the Services.
        </li>
        <li>
          Changes. First Orion may make changes to the Euro Portal, Services,
          APIs, applications, systems, or platforms that it reasonably considers
          necessary or useful to maintain or enhance quality, delivery,
          competitiveness, cost efficiency, performance, security, legal
          compliance, or compliance with Distribution Partner requirements.
          First Orion will use reasonable efforts to provide at least thirty
          (30) days’ prior notice of a material change. First Orion will not
          materially reduce the functionality, performance, or security of the
          Services during an applicable Order term unless required by applicable
          law or a Distribution Partner. If such a required change materially
          and adversely affects Customer’s use, Customer may terminate the
          affected Services and First Orion will refund prepaid Fees
          attributable to the unused portion of those Services.
        </li>
        <li>
          Distribution. The applicable Distribution Partners will be identified
          in the Order or Euro Portal. Onboarding time may vary by Distribution
          Partner.
        </li>
        <li>
          Education and Training. First Orion will make reasonable online
          instructions, tutorials, or other training materials available to
          facilitate Customer’s use of the Services.
        </li>
        <li>
          Customer Support. Customer support is available Monday through Friday
          from 08:00 to 17:00 GMT through Zendesk in the Euro Portal or at
          <a href="mailto:eu.enterprisesupport@firstorion.com"
            >eu.enterprisesupport&#64;firstorion.com</a
          >. Customer authorises First Orion to access the Customer account when
          reasonably necessary to provide support, subject to the Agreement.
        </li>
        <li>
          Reporting. Standard reports will be made available through the Euro
          Portal at no additional charge.
        </li>
        <li>
          Delivery Limitations. Delivery and display of Content depend on the
          applicable Distribution Partner, Device, network, and other technical
          limitations. A Device may not support all Content, and the appearance
          of a Call Logo or Call Reason may vary. If a Device does not support
          the specified Content, the call may be delivered with an Inform
          Display only.
        </li>
      </ol>
      <p><strong>5. Customer Responsibilities</strong></p>
      <ol type="a">
        <li>
          Compliance and Use Restrictions. Customer is responsible for its use
          of the Services, Documentation, Customer Data, and information
          provided for the Services, except to the extent unauthorised use
          results from First Orion’s breach of the Agreement. Customer will (i)
          use the Services only in accordance with the Agreement, Documentation,
          and applicable law; (ii) use commercially reasonable efforts to
          prevent unauthorised access or use and notify First Orion promptly of
          any unauthorised access or use; (iii) reasonably cooperate with lawful
          requests from regulators, law enforcement, and third parties used to
          provide the Services; and (iv) comply with Section 12. Except as
          expressly permitted in an Order, Customer will not transfer, resell,
          lease, license, or make the Services available to third parties; copy
          or distribute the Services, Documentation, or Euro Portal except as
          permitted by law; circumvent technical limitations; reverse engineer
          the Services; or interfere with the normal operation of the Services.
        </li>
        <li>
          Agents. Customer may appoint Agents to act on its behalf in connection
          with the Services. Customer will ensure that each Agent is authorised
          and complies with the Agreement, and Customer is responsible for each
          Agent’s acts and omissions as if they were Customer’s own. First Orion
          may rely on the authority of an Agent reasonably believed to act for
          Customer.
        </li>
        <li>
          Business Process Outsourcing. Customer may use the Services as a BPO
          only if expressly authorised in an Order. Before establishing a
          Program for an enterprise customer, Customer will notify First Orion
          in writing of the enterprise customer’s identity. Each enterprise
          customer is subject to First Orion’s and the applicable Distribution
          Partner’s vetting and approval. Customer represents and warrants that
          it has authority under a valid written agreement to deliver branded
          calls for each enterprise customer and will require each enterprise
          customer to comply with applicable provisions of the Agreement.
        </li>
        <li>
          Branded Calling Compliance. Customer will comply with the Acceptable
          Use Policy (<a
            href="https://firstorion.com/legal#euro-aup"
            target="_blank"
            rel="noopener"
            >https://firstorion.com/legal#euro-aup</a
          >) and applicable Pass-Through Terms
          <a
            href="https://firstorion.com/legal#euro-pass-through-terms"
            target="_blank"
            rel="noopener"
            >https://firstorion.com/legal#euro-pass-through-terms</a
          >) when using the Services.
        </li>
        <li>
          Programs. Customer is responsible for establishing and maintaining
          Programs in accordance with the Documentation and information provided
          through the Euro Portal.
        </li>
        <li>
          Customer Calls. Customer may use the Services for its own calls by
          designating Content in accordance with the Documentation.
        </li>
        <li>
          Affiliate and Subsidiary Calls. Customer may use the Services for an
          Affiliate or subsidiary only if expressly authorised in an Order.
          Customer will notify First Orion before establishing a Program for a
          new Affiliate or subsidiary, and each entity is subject to applicable
          vetting and approval.
        </li>
        <li>
          Permitted Third-Party Use. Use by an authorised Agent, Affiliate,
          subsidiary, BPO, enterprise customer, or Partner in accordance with
          the Agreement does not violate Section 5(a).
        </li>
      </ol>
      <p><strong>6. Ownership and Reservation of Rights</strong></p>
      <p>
        As between the parties, First Orion owns and reserves all right, title,
        and interest in and to the Euro Portal, Services, Documentation, First
        Orion’s Confidential Information, Usage Data, and feedback or
        suggestions provided by or on behalf of Customer. As between the
        parties, Customer owns and reserves all right, title, and interest in
        and to Customer’s Confidential Information and Customer Data, subject to
        First Orion’s rights to process Customer Data under the Agreement.
      </p>
      <p><strong>7. Customer Data and Usage Data</strong></p>
      <ol type="a">
        <li>
          Processing and Protection of Customer Data. Customer authorises First
          Orion and its Affiliates to process Customer Data during the period in
          which First Orion provides the Services and during any
          post-termination retention required by applicable law or the Data
          Processing Addendum, solely to (i) provide, support, secure, and
          improve the Services and Euro Portal; (ii) mitigate fraud or other
          harm; and (iii) comply with applicable law. Customer authorises First
          Orion to disclose Customer Data to applicable Distribution Partners to
          manage call traffic, manage branding activity, conduct Customer
          vetting, provide advanced support, provide the Services, and confirm
          compliance with applicable law. First Orion will maintain commercially
          reasonable administrative, technical, and physical safeguards designed
          to protect Customer Data against unauthorised access, use, alteration,
          or disclosure. The Data Processing Addendum applies when First Orion
          processes Personal Data on Customer’s behalf as a processor.
        </li>
        <li>
          Usage Data. First Orion may collect and analyse Usage Data and may use
          de-identified and aggregated Usage Data during and after the
          applicable Order term to maintain, improve, and enhance First Orion’s
          products and services. First Orion will not use Usage Data in a manner
          that identifies Customer, an individual, or Customer’s Confidential
          Information.
        </li>
      </ol>
      <p><strong>8. Use and Suspension</strong></p>
      <ol type="a">
        <li>
          Grounds for Suspension. First Orion may suspend all or part of the
          Services if it determines in good faith that (i) Customer has breached
          the Agreement; (ii) provision of the Services is prohibited by
          applicable law; (iii) Customer’s use threatens the security,
          integrity, or availability of the Services; (iv) information in the
          Customer account is untrue, inaccurate, incomplete, or fraudulent; or
          (v) Customer’s use may cause material harm to First Orion, the
          Services, or others using the Services, including Distribution
          Partners. Except where immediate suspension is reasonably necessary to
          prevent material harm or comply with law or a Distribution Partner
          directive, First Orion will provide prior notice.
        </li>
        <li>
          Distribution Partner Suspensions. The Services may be suspended in
          whole or in part, including at an enterprise, business, or individual
          A Number level, in response to a request or directive from a
          Distribution Partner. First Orion will notify Customer promptly and
          identify required corrective actions, if applicable.
        </li>
        <li>
          Cooperation and Fees During Suspension. Customer will reasonably
          cooperate in investigating events that resulted in suspension.
          Customer remains responsible for Fees during any suspension resulting
          from Customer's breach of the Agreement, violation of applicable law,
          fraudulent activity, or failure to comply with a corrective action
          reasonably requested by First Orion or a Distribution Partner.
        </li>
        <li>
          Additional Restrictions. First Orion may impose additional
          restrictions or prohibitions on use of the Services when required by
          applicable law or a Distribution Partner. First Orion will notify
          Customer as soon as reasonably practicable, and Customer will comply
          with the restriction or prohibition.
        </li>
      </ol>
      <p><strong>9. Term and Termination</strong></p>
      <ol type="a">
        <li>
          Term. Unless earlier terminated under the Agreement, the term for the
          Services will be stated in the applicable Order. If no term is stated,
          the Services will continue month-to-month, and either party may
          terminate effective at the end of a monthly period by providing at
          least thirty (30) days’ written notice.
        </li>
        <li>
          Termination for Convenience. Either party may terminate these Terms
          for any reason upon thirty (30) days’ written notice. If an Order
          remains in effect, the Terms will continue to apply to that Order
          until the Order expires or is terminated in accordance with its terms.
        </li>
        <li>
          Termination for Material Breach. Either party may terminate the
          affected Order or Services if the other party materially breaches the
          Agreement and fails to cure the breach within thirty (30) days after
          written notice. A party may terminate all Orders only if the breach
          materially affects the parties’ overall relationship or cannot
          reasonably be limited to the affected Order or Services. A breach of
          the Acceptable Use Policy constitutes a material breach.
        </li>
        <li>
          Additional Termination Right. First Orion may terminate all or a
          portion of the Services provided under an Order to the extent a
          Distribution Partner precludes or materially modifies First Orion’s
          ability to provide such Services. First Orion will provide notice of a
          termination under this section promptly upon becoming aware of the
          circumstances giving rise to the termination right. In the event of a
          termination under this Section 9(d), First Orion will refund to
          Customer any prepaid Fees for unused Services.
        </li>
      </ol>
      <p><strong>10. Fees and Payments</strong></p>
      <ol type="a">
        <li>
          Fees. Customer will pay the Fees stated in each Order. Fees will be
          payable in the currency stated in the Order and, unless the Order
          provides otherwise, are non-cancellable and non-refundable. Except as
          stated in an Order, First Orion may adjust Fees for a renewal term by
          providing at least sixty (60) days’ written notice before the end of
          the then-current term.
        </li>
        <li>
          Taxes. All amounts payable by Customer are exclusive of VAT and any
          other applicable taxes, duties, or levies, which will be payable by
          Customer in addition to the Fees due. First Orion will include any
          applicable VAT on its invoices and will provide valid VAT invoices
          where required by law. Customer will not be responsible for any taxes
          based on First Orion’s income, profits, or payroll. Customers exempt
          from paying certain taxes must provide necessary exemption information
          or a valid exemption certificate issued by the appropriate authority
          via email to
          <a href="mailto:accounting@firstorion.com"
            >accounting&#64;firstorion.com</a
          >. Once the exemption request is approved, Customer will be exempt on
          a going-forward basis. If the appropriate authority determines, at any
          time, that Customer is not exempt from paying any taxes, Customer will
          promptly pay such taxes to First Orion, plus any applicable interest
          or penalties. Notwithstanding the foregoing, First Orion may specify
          Fees for Services that are inclusive of taxes and in such event the
          invoice provided to the Customer will state that the invoiced Fees are
          inclusive of taxes. If the Customer is not subject to, or exempt from,
          all or any portion of the taxes, for those Fees which are inclusive of
          taxes, there will be no adjustment to the Fees.
        </li>
        <li>
          Billing. Customer will provide accurate and complete billing
          information and keep it current. Customer authorises First Orion, its
          Affiliates, payment processors, and other third parties acting on its
          behalf to charge or refund Customer’s designated payment method or
          bank account and to make inquiries reasonably necessary to validate
          the account or payment information and process payment.
        </li>
        <li>Payment – Prepaid Services.</li>
        <li>
          If Customer purchases a prepaid plan, Fees are payable in advance for
          the Subscription Period. First Orion may use a third-party payment
          processor, and Customer will provide information reasonably required
          to process payment and authorises First Orion or the processor to
          charge Fees when due.
          <ol type="i">
            <li>
              Customer may cancel a prepaid plan at any time, effective at the
              end of the current Subscription Period. If Customer reactivates
              before the end of that period, billing will continue without
              interruption. Prepaid plans will automatically renew for
              successive Subscription Periods unless Customer cancels before the
              renewal date.
            </li>
            <li>
              Each prepaid plan includes a monthly limit on branded calls. When
              Customer reaches the limit, branding will stop without overage
              charges unless Customer purchases additional branded calls. An
              additional-call purchase is a one-time charge and does not change
              or renew the underlying plan.
            </li>
            <li>
              Customer may upgrade a prepaid plan at any time. A downgrade
              becomes effective at the end of the current Subscription Period.
              Call Authentication and INFORM with Logo are not included with
              prepaid plans.
            </li>
          </ol>
        </li>
        <li>Payment – Postpaid Services.</li>
        <li>
          For postpaid Services, Fees, including usage-based Fees such as
          per-branded-call charges, will be billed in arrears and invoiced
          monthly unless the Order states otherwise. Monthly or minimum Fees may
          be prorated for a partial first or last month.
          <ol type="i">
            <li>
              Payments are due within thirty (30) days after the invoice date
              (the "Due Date"). If Customer fails to pay any undisputed amount
              by the Due Date, First Orion may charge interest on the overdue
              amount at the rate and in the manner permitted under the Late
              Payment of Commercial Debts (Interest) Act 1998, as amended from
              time to time. For the avoidance of doubt, First Orion reserves all
              rights and remedies available under that Act, including statutory
              compensation and recovery of costs to the extent permitted by law.
              If any undisputed invoice remains unpaid more than thirty (30)
              days after the Due Date, First Orion may suspend the affected
              Services upon at least five (5) days’ prior written notice.
              Payments will be made by bank transfer or other electronic method
              reasonably required by First Orion. First Orion may, with
              Customer’s agreement where required, delegate invoicing, billing,
              or collection to a third party.
            </li>
          </ol>
        </li>
        <li>
          Payment through Partner. If Customer purchases Services through a
          Partner, Customer will pay the applicable fees to the Partner in
          accordance with Customer’s agreement with the Partner (the "Partner
          Agreement"). First Orion may suspend or terminate the Services for the
          Partner’s failure to remit payment only if First Orion provides
          Customer with prior written notice and a reasonable opportunity to
          arrange continued service directly with First Orion or another
          authorised Partner. The Agreement governs Customer’s access to and use
          of the Services. The Partner Agreement governs the commercial
          relationship between Customer and the Partner, including any rights or
          obligations that apply solely between them. To the extent of a
          conflict concerning Customer’s access to or use of the Services, the
          Agreement will control. Customer will seek enforcement of rights
          granted solely under the Partner Agreement against the Partner and not
          First Orion. First Orion may assume direct billing for the Services
          upon prior written notice to Customer. The notice will specify the
          effective date of the change and the Fees payable directly to First
          Orion. Customer will not be required to pay First Orion any amount
          previously paid to the Partner for the same Services. For purposes of
          Section 14, the Fees paid or payable by Customer to the Partner for
          the affected Services will be treated as Fees paid or payable by
          Customer under the Agreement.
        </li>
      </ol>
      <p><strong>11. Confidentiality</strong></p>
      <ol type="a">
        <li>
          Confidential Information. Either party (the "Disclosing Party") may
          disclose Confidential Information to the other party (the
          "Recipient"). "Confidential Information" means non-public information
          disclosed by or on behalf of the Disclosing Party concerning its
          business, technology, proprietary software, pricing, business plans,
          forecasts, marketing information, trade secrets, financial
          performance, or strategies that is marked confidential or that
          reasonably should be understood to be confidential based on its nature
          or the circumstances of disclosure.
        </li>
        <li>
          Obligations. The Recipient will protect the Disclosing Party’s
          Confidential Information using at least reasonable care and no less
          than the care it uses for its own confidential information of similar
          sensitivity. The Recipient will use Confidential Information only as
          necessary to perform or exercise rights under the Agreement and will
          disclose it only to employees, contractors, and agents who have a need
          to know and are bound by confidentiality obligations.
        </li>
        <li>
          Exceptions. Confidential Information will not include information
          that: (i) is now generally known or available or which hereafter,
          through no act or failure to act on the part of Recipient, becomes
          generally known or available; (ii) is rightfully known to Recipient at
          the time of receiving such information; (iii) is furnished to
          Recipient by a third party without restriction on disclosure and
          without a breach by such third party of any confidentiality
          undertaking with respect thereto; or (iv) is independently developed
          by Recipient without the use of the Disclosing Party’s Confidential
          Information. Recipient may also disclose Confidential Information if
          disclosure is required by operation of law or if required by a court,
          tribunal or administrative agency; provided that, unless prohibited by
          law, the Recipient shall give the Disclosing Party as much advance
          written notice as is reasonably practicable under the circumstances so
          as to permit the Disclosing Party to take commercially reasonable
          actions at its own expense to prevent disclosure.
        </li>
        <li>
          Remedies. Each party acknowledges that monetary damages may be
          inadequate for unauthorised use or disclosure of Confidential
          Information and that the affected party may seek appropriate
          injunctive or equitable relief without waiving other rights or
          remedies.
        </li>
        <li>
          Return, Destruction, and Retention. Upon the Disclosing Party's
          written request or upon expiration or termination of the Agreement,
          the Recipient will promptly return or destroy the Disclosing Party's
          Confidential Information in its possession or control, in any form or
          medium, including paper records, electronic records, databases, and
          other stored information, and upon request provide written
          certification of such return or destruction. Notwithstanding the
          foregoing, the Recipient may retain copies of Confidential Information
          (i) as required by applicable law, regulation, legal process, or
          governmental authority, (ii) pursuant to bona fide records-retention
          policies, or (iii) in routine backup, disaster-recovery, security, or
          archival systems, provided that any retained Confidential Information
          remains subject to the confidentiality obligations set forth herein
          and is not accessed, used, or disclosed except as permitted by the
          Agreement. To the extent Confidential Information cannot reasonably be
          removed from backup or archival systems, the Recipient will not be
          required to delete such information until such systems are overwritten
          or retired in the ordinary course of business.
        </li>
        <li>
          Survival. The obligations set forth in this Section 11 will survive
          expiration or termination of the Agreement for a period of five (5)
          years; provided, however, that obligations relating to Confidential
          Information that constitutes a trade secret under applicable law will
          survive for so long as such information remains a trade secret. Any
          Confidential Information retained pursuant to Section 11(e) will
          remain subject to the confidentiality obligations set forth in this
          Section 11 for so long as it is retained.
        </li>
      </ol>
      <p><strong>12. Representations, Warranties, and Disclaimers</strong></p>
      <ol type="a">
        <li>
          Mutual Representations. Each party represents and warrants that (i) it
          is validly existing and in good standing under the laws of its place
          of establishment or incorporation and (ii) it has full power and
          authority to enter into and perform its obligations under the
          Agreement.
        </li>
        <li>
          Customer Representations. Customer represents and warrants that (i) it
          is eligible to register for and use the Services; (ii) information
          provided in connection with the Customer account and Services is
          accurate and complete; (iii) it has all rights necessary to use each A
          Number and Content submitted for the Services; (iv) it will comply
          with laws applicable to its business, calls, Content, and use of the
          Services; (v) its employees, contractors, Agents, Affiliates,
          subsidiaries, and enterprise customers will comply with applicable
          provisions of the Agreement; and (vi) it will not use the Services for
          fraudulent or illegal activity or in a way that interferes with the
          normal operation of the Services.
        </li>
        <li>
          DISCLAIMER. WITHOUT LIMITING EITHER PARTY’S EXPRESS WARRANTIES AND
          OBLIGATIONS UNDER THE AGREEMENT, AND EXCEPT AS EXPRESSLY PROVIDED IN
          THIS SECTION 12, THE SERVICES ARE PROVIDED "AS IS." FIRST ORION MAKES
          NO WARRANTY OF ANY KIND, WHETHER EXPRESS, IMPLIED, STATUTORY, OR
          OTHERWISE, AND, TO THE FULLEST EXTENT PERMITTED BY LAW, SPECIFICALLY
          DISCLAIMS ALL IMPLIED WARRANTIES, INCLUDING ANY IMPLIED WARRANTY OF
          MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR
          NON-INFRINGEMENT. CUSTOMER ACKNOWLEDGES THAT THE INTERNET AND
          TELECOMMUNICATIONS PROVIDERS’ NETWORKS ARE INHERENTLY INSECURE.
          ACCORDINGLY, FIRST ORION WILL NOT BE LIABLE FOR ANY ALTERATION,
          INTERCEPTION, OR LOSS OF CUSTOMER DATA WHILE IN TRANSIT OVER THE
          INTERNET OR A TELECOMMUNICATIONS PROVIDER’S NETWORK, EXCEPT TO THE
          EXTENT CAUSED BY FIRST ORION’S BREACH OF ITS EXPRESS OBLIGATIONS UNDER
          THE AGREEMENT, INCLUDING THE DATA PROCESSING ADDENDUM. NOTHING IN THIS
          SECTION 12(c) EXCLUDES, LIMITS, OR MODIFIES FIRST ORION’S OBLIGATIONS
          OR LIABILITY UNDER THE DATA PROCESSING ADDENDUM.
        </li>
      </ol>
      <p><strong>13. Indemnification</strong></p>
      <ol type="a">
        <li>Indemnification by First Orion</li>
        <li>
          Scope of Indemnification. First Orion will defend Customer and its
          officers, directors, employees, and Affiliates (collectively, the
          "Customer Indemnified Parties") against any third-party claim, demand,
          suit, or proceeding alleging that Customer’s authorised use of the
          Services in accordance with the Agreement infringes or misappropriates
          a third party’s intellectual property rights (an "Infringement
          Claim"). First Orion will indemnify the Customer Indemnified Parties
          against reasonable legal fees and costs incurred by First Orion in
          defending the Infringement Claim and any damages, judgments,
          settlements, or other amounts finally awarded against, or paid in a
          settlement entered into in accordance with Section 13(c) on behalf of,
          a Customer Indemnified Party as a result of the Infringement Claim.
          <ol type="i">
            <li>
              Infringement Remedies. If the Services become, or in First Orion’s
              reasonable opinion are likely to become, the subject of an
              Infringement Claim, First Orion may, at its option and expense:
              (A) procure the right for Customer to continue using the affected
              Services; (B) modify or replace the affected Services so that they
              are no longer infringing without materially reducing their
              functionality; or (C) if neither of the foregoing options is
              reasonably practicable, terminate the affected Services or
              applicable Order and refund any prepaid Fees attributable to the
              unused portion of the terminated Services.
            </li>
            <li>
              Exclusions. First Orion will have no obligation under this Section
              13(a) to the extent an Infringement Claim arises from: (A)
              Customer’s use of the Services in breach of the Agreement or
              Documentation; (B) any modification of the Services not made or
              authorised by First Orion; (C) the combination, operation, or use
              of the Services with any product, service, software, data,
              content, process, or material not provided or authorised by First
              Orion, where the Services would not otherwise be infringing; (D)
              Customer Data, Content, or other materials provided by or on
              behalf of Customer; or (E) Customer’s continued use of the
              affected Services after First Orion has provided a non-infringing
              replacement or modification or instructed Customer to discontinue
              that use.
            </li>
          </ol>
        </li>
        <li>
          Indemnification by Customer. Customer will defend First Orion, its
          officers, directors, employees, and Affiliates (collectively, the
          "First Orion Indemnified Parties") against any third-party claim,
          demand, suit, proceeding, investigation, or enforcement action arising
          out of or relating to: (i) Customer’s breach of Section 5; (ii)
          Customer Data, Content, or other materials provided by or on behalf of
          Customer, including any allegation that such items infringe,
          misappropriate, or otherwise violate a third party’s rights; (iii)
          Customer’s violation of applicable law; or (iv) Customer’s fraudulent,
          unlawful, or wilful misconduct (each, a "Customer Indemnifiable
          Claim"). Customer will indemnify the First Orion Indemnified Parties
          against reasonable legal fees and costs incurred by Customer in
          defending the Customer Indemnifiable Claim; any damages, judgments,
          settlements, or other amounts finally awarded against, or paid in a
          settlement entered into in accordance with Section 13(c) on behalf of,
          a First Orion Indemnified Party; and, to the extent legally
          permissible, any governmental fines or penalties finally imposed on a
          First Orion Indemnified Party, in each case as a result of the
          Customer Indemnifiable Claim.
        </li>
        <li>
          Conditions of Indemnification. A party seeking defence or
          indemnification under this Section 13 (the "Indemnified Party") will:
          (i) promptly provide the party from whom defence or indemnification is
          sought (the "Indemnifying Party") with written notice of the
          applicable Infringement Claim or Customer Indemnifiable Claim (each,
          an "Indemnifiable Claim"), provided that any delay in providing notice
          will relieve the Indemnifying Party of its obligations only to the
          extent the delay materially prejudices the defence of the
          Indemnifiable Claim; (ii) give the Indemnifying Party sole control of
          the defence and settlement of the Indemnifiable Claim, to the extent
          permitted by applicable law and the relevant governmental authority;
          and (iii) provide reasonable cooperation and assistance, at the
          Indemnifying Party’s expense. The Indemnified Party may participate in
          the defence through counsel of its choice at its own expense. The
          Indemnifying Party will not settle an Indemnifiable Claim without the
          Indemnified Party’s prior written consent, which may not be
          unreasonably withheld, conditioned, or delayed, unless the settlement:
          (A) provides the Indemnified Party with a full and unconditional
          release from the Indemnifiable Claim; (B) does not include an
          admission of fault, wrongdoing, or liability by the Indemnified Party;
          (C) does not impose any monetary or non-monetary obligation on the
          Indemnified Party; and (D) does not require the Indemnified Party to
          take or refrain from taking any action or otherwise restrict its
          business, products, services, or customers.
        </li>
        <li>
          Exclusive Remedy. This Section 13 states the Indemnifying Party’s sole
          liability to, and the Indemnified Party’s exclusive remedy for, the
          third-party claims expressly covered by Sections 13(a) and 13(b). This
          Section 13 does not limit either party’s remedies for a direct breach
          of the Agreement.
        </li>
      </ol>
      <p><strong>14. Limitation of Liability</strong></p>
      <ol type="a">
        <li>
          General Liability Cap. To the extent permitted by law, each party’s
          total cumulative liability arising out of or related to the Agreement
          or Services, whether in contract, tort (including negligence), or
          otherwise, will not exceed the Fees paid or payable by Customer under
          the applicable Order during the twelve (12) months preceding the first
          event giving rise to the applicable claim.
        </li>
        <li>
          Exclusion of Certain Damages. To the extent permitted by law, neither
          party will be liable to the other for any indirect, incidental,
          consequential, punitive, special, or exemplary damages, or for any
          loss of profits, revenue, business, reputation, goodwill, in each case
          to the extent such loss or damage is indirect or consequential,
          regardless of the legal theory on which liability is based and even if
          the party has been advised of the possibility of such loss or damage.
          Except as provided in Section 14(c), neither party will be liable to
          the other for loss of data or the cost of cover or substitute goods or
          services.
        </li>
        <li>
          Enhanced Cap. Notwithstanding Section 14(a), each party’s total
          cumulative liability arising from its breach of Section 11
          (Confidentiality), its obligations under Section 13 (Indemnification),
          or its obligations under the Data Processing Addendum will not exceed
          three (3) times the Fees paid or payable by Customer under the
          applicable Order during the twelve (12) months preceding the first
          event giving rise to the applicable claim. The exclusions in Section
          14(b) will not apply to amounts payable to a third party under Section
          13 or to loss of Customer Data to the extent caused by First Orion’s
          breach of the Data Processing Addendum.
        </li>
        <li>
          Liabilities Not Limited. Nothing in the Agreement excludes or limits
          either party’s liability for: (i) fraud or fraudulent
          misrepresentation; (ii) death or personal injury caused by its
          negligence; (iii) wilful misconduct; (iv) misappropriation of the
          other party’s trade secrets; or (v) any other liability that cannot
          lawfully be excluded or limited.
        </li>
        <li>
          Allocation of Risk. The provisions of this Section 14 allocate the
          risks between the parties, and the parties have relied on these
          limitations in determining whether to enter into the Agreement.
        </li>
      </ol>
      <p><strong>15. General</strong></p>
      <ol type="a">
        <li>
          No Waiver. No failure or delay by either party in exercising a right
          or enforcing a provision of the Agreement constitutes a waiver. A
          waiver must be in writing and signed by the party against whom it is
          asserted. Titles and headings are for convenience only and do not
          affect interpretation.
        </li>
        <li>
          Order of Precedence. If the documents comprising the Agreement
          conflict, the following order controls: (i) the Data Processing
          Addendum, but solely with respect to the processing, protection,
          transfer, retention, deletion, and security of Personal Data, and not
          with respect to Fees, payment obligations, indemnification, limitation
          of liability, termination rights, audit rights, governing law, dispute
          resolution, or other commercial terms unless expressly stated
          otherwise in the Data Processing Addendum; (ii) the applicable Order;
          (iii) these Terms; (iv) the Acceptable Use Policy; (v) any applicable
          Pass-Through Terms; (vi) other terms expressly incorporated by
          reference; and (vii) the Documentation. For clarity, no update posted
          to the Legal Dashboard will amend an Order or override any conflicting
          term expressly negotiated in an Order unless the parties agree
          otherwise in writing. If documents at the same level conflict, the
          provision that is more specific to the applicable Service or subject
          matter will control.
        </li>
        <li>
          Assignment. Neither party may assign, delegate, or otherwise transfer
          the Agreement, in whole or in part, without the other party’s prior
          written consent, which is not to be unreasonably withheld,
          conditioned, or delayed; provided that either party may assign the
          Agreement without consent to an Affiliate or in connection with a
          merger, reorganisation, sale of all or substantially all of its
          assets, or change of control. Subject to this Section, the Agreement
          will be binding on each party and each party’s successors and assigns.
        </li>
        <li>
          Relationship. The parties are independent contractors. Nothing in the
          Agreement creates an employer-employee relationship, partnership,
          joint venture, franchise, or agency relationship between First Orion
          and Customer. Customer’s appointment of an Agent under the Agreement
          does not make Customer an agent of First Orion or First Orion an agent
          of Customer. Each party is responsible for its own personnel, agents,
          activities, costs, claims, and liabilities. Neither party may bind the
          other or represent that it has authority to do so.
        </li>
        <li>
          Severability. If any provision of the Agreement is held by a court or
          other tribunal of competent jurisdiction to be unenforceable, that
          provision will be limited or eliminated to the minimum extent
          necessary to make it enforceable and, in any event, the rest of the
          Agreement will continue in full force and effect.
        </li>
        <li>
          Notices and Consent to Electronic Delivery. Notices to First Orion
          under the Agreement must be sent to
          <a href="mailto:legal@firstorion.com">legal&#64;firstorion.com</a>.
          Formal contractual notices to Customer will be sent to the email
          address stated in the applicable Order or, if there is no Order, the
          primary email address associated with the Customer account.
          Operational notices may be delivered through the Euro Portal or the
          contact information in the Customer account. Electronic notice has the
          same legal effect as a physical copy. Operational notices are deemed
          received within twenty-four (24) hours after posting or sending;
          formal contractual notices are effective when received, unless the
          applicable Order states otherwise.
        </li>
        <li>
          Force Majeure. No failure, delay, or default in performance of any
          obligation of a party will constitute an event of default or breach of
          the Agreement to the extent that such failure to perform, delay, or
          default arises out of a cause, existing or future, that is beyond the
          control and without negligence of such party, including action or
          inaction of governmental, civil, or military authority, fire, strike,
          lockout, or other labour dispute, flood, terrorist act, war, riot,
          theft, earthquake, or other natural disaster. The party affected by
          such cause will take all reasonable actions to minimise the
          consequences of such cause.
        </li>
        <li>
          Governing Law. Unless prohibited by applicable law, the Agreement is
          governed by the laws of England and Wales. The parties submit to the
          exclusive jurisdiction of the courts of England and Wales for disputes
          arising out of or relating to the Agreement, including non-contractual
          disputes or claims.
        </li>
        <li>
          Entire Agreement. The Agreement constitutes the entire agreement
          between the parties concerning its subject matter and supersedes prior
          or contemporaneous proposals, statements, sales materials,
          presentations, and agreements concerning that subject matter.
          Information or advice provided by First Orion does not create a
          warranty or expand First Orion’s obligations unless expressly included
          in the Agreement. A term in Customer’s vendor-registration materials,
          portal, purchase order, or similar document is evidence only of
          Customer’s internal process. Such terms have no force or effect and
          are not binding on First Orion, even if First Orion accepts or signs
          the document after Customer enters into the Agreement.
        </li>
        <li>
          Survival. Expiration or termination of the Agreement will not affect
          any rights, obligations, or liabilities that accrued prior to such
          expiration or termination. The provisions of Sections 6 (Ownership and
          Reservation of Rights), 7 (Customer Data and Usage Data), 10 (Fees and
          Payments) to the extent of any unpaid Fees or other accrued payment
          obligations, 11 (Confidentiality), 13 (Indemnification), 14
          (Limitation of Liability), and 15 (General), together with any other
          provisions that by their nature are intended to survive, will survive
          expiration or termination of the Agreement. Notwithstanding the
          foregoing, obligations relating to Confidential Information that
          constitutes a trade secret under applicable law will survive for so
          long as such information remains a trade secret, and any Confidential
          Information retained pursuant to Section 11(e) will remain subject to
          the confidentiality obligations of Section 11 for so long as it is
          retained.
        </li>
      </ol>
    </div>
    <div class="scroll-fade" [class.scroll-fade--hidden]="canUnderstand"></div>
  </div>
  <div class="modal-footer flex-column align-items-start w-100">
    <div class="d-block w-100">
      <button
        type="button"
        class="btn w-25 float-end btn-dark border-2 pr-3"
        [disabled]="!canUnderstand"
        (click)="understandTerms()"
      >
        I Understand
      </button>
      <button
        type="button"
        class="btn w-25 float-end btn-outline-dark border-2 pr-3"
        (click)="modalRef?.hide()"
      >
        Close
      </button>
    </div>
    <div class="scroll-hint text-muted text-end w-100" *ngIf="!canUnderstand">
      Scroll to the bottom to continue
    </div>
  </div>
</ng-template>
